module.exports = (__parcel__import__("./" + "Native.c8873ec0.js")).then(() => parcelRequire('dqcZH'));